const styles = theme => ({
  layout: {
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    position: "relative",
    zIndex: 1
  },
  templateContainer: {
    flexGrow: 1,
    minHeight: 0,
    paddingBottom: 80
  },
  auctionTitle: {
    fontFamily: "Oswald",
    fontWeight: 200,
    fontSize: "3.8rem",
    color: theme.palette.common.white
  },
  instructions: {
    color: theme.palette.common.white,
    display: "flex",
    alignItems: "baseline",
    fontWeight: 100,
    fontSize: "1.5rem"
  },
  instructionsBold: {
    color: theme.palette.common.white,
    fontFamily: "Oswald",
    fontWeight: 600,
    fontSize: "inherit",
    padding: `0 ${theme.spacing.unit}px`
  },
  topLine: {
    flexBasis: 100,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: theme.spacing.unit * 8
  },
  bottomLine: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
    display: "flex",
    alignItems: "center",
    padding: `0 ${theme.spacing.unit * 6}px`,
    backgroundColor: "rgba(0,0,0,0.1)",
    justifyContent: "space-between",
    zIndex: 2
  },
  logo: {
    height: 50
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/styles.js